import { render, staticRenderFns } from "./TeamGramMenu.vue?vue&type=template&id=4e8bbb72&scoped=true"
import script from "./TeamGramMenu.vue?vue&type=script&lang=js"
export * from "./TeamGramMenu.vue?vue&type=script&lang=js"
import style0 from "./TeamGramMenu.vue?vue&type=style&index=0&id=4e8bbb72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8bbb72",
  null
  
)

export default component.exports